import EmbedPdf from './EmbedPdf'

export default EmbedPdf
// eslint-disable-next-line import/export
export * from './EmbedPdf'
